@if (authorized) {
    <div class="h-100 overflow-auto">
        <div class="container-sm-fluid pt-3 px-sm-4">
            @if ((tabs$ | async); as tabs) {
                @if (tabs.length > 1) {
                    <dx-tabs
                        keyExpr="key"
                        [items]="tabs"
                        [selectedItemKeys]="[selectedTab]"
                        [iconPosition]="'start'"
                        class="mb-2"
                        (onItemClick)="selectedTab = $event.itemData.key"
                        [scrollByContent]="true"
                        [scrollingEnabled]="true"
                        [showNavButtons]="true"
                    ></dx-tabs>
                }
            }
        </div>

        <!-- A block with auto height, so the tabs' h-100 / height: 100% content doesn't size itself to the scrolling wrapper. -->
        <div>
            @if (selectedTab == 'my-score') {
                <app-my-score [employeeId]="employeeId$ | async" [daysLookBack]="7" containerClass="px-4 pb-4"></app-my-score>
            } @else if (selectedTab == 'profile') {
                <app-employee-profile [isEmployee]="(isEmployee$ | async) ?? false" (profileSaved)="onProfileSaved()"></app-employee-profile>
            } @else if (selectedTab == 'schedule') {
                <app-schedule [employeeId]="employeeId$ | async" [offset]="146" [embedded]="true"></app-schedule>
            } @else if (selectedTab == 'time-logs') {
                <app-time-logs [employeeId]="employeeId$ | async" [offset]="136" [embedded]="true"></app-time-logs>
            } @else if (selectedTab == 'time-off') {
                <app-time-off-tabs [employeeId]="employeeId$ | async" [offset]="188" [embedded]="true"></app-time-off-tabs>
            } @else if (selectedTab == 'request-forms') {
                <app-change-requests [employeeId]="employeeId$ | async" [offset]="136" [embedded]="true"></app-change-requests>
            } @else if (selectedTab == 'history') {
                <app-user-history [employeeId]="employeeId$ | async" [offset]="136" [embedded]="true"></app-user-history>
            }
        </div>
    </div>
}
